// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M11.9984 4.32008L8.00905 1.82764L1.625 5.65694L2.65377 7.37206L2.99694 7.16622V22.0001H7V15H9V22.0001H15V15H17V22.0001H20.9999V7.16622L21.343 7.37206L22.3718 5.65694L15.9878 1.82764L11.9984 4.32008ZM7 8.99805H9.00391V11.002H7V8.99805ZM17.0039 8.99805V11.002H15V8.99805H17.0039Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-city-9-filled')
export default class City9FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'city-9-filled',
    }
  }
}
